import React from 'react';
import UserRole, { getUserRoleLabel } from '../../../types/UserRole';
import User from '../../../types/User';
import CustomSelect from '../../../components/CustomSelect/CustomSelect';

interface UserRoleSelectorProps {
  selectedRole: UserRole;
  handleChange: (value: string) => void;
  loggedInUser: User;
  fullWidth?: boolean;
}

function UserRoleSelector({
  selectedRole,
  handleChange,
  loggedInUser,
  fullWidth
}: Readonly<UserRoleSelectorProps>): React.ReactElement {
  return (
    <CustomSelect
      label='Role'
      value={selectedRole}
      onValueChange={handleChange}
      options={[
        { value: 'READ_ONLY', label: getUserRoleLabel('READ_ONLY') },
        { value: 'READ_WRITE', label: getUserRoleLabel('READ_WRITE') },
        {
          value: 'ORGANISATION_ADMIN',
          label: getUserRoleLabel('ORGANISATION_ADMIN')
        },
        ...(loggedInUser?.role === 'JAPETO_ADMIN' ||
        loggedInUser?.role === 'SUPER_ADMIN'
          ? [
              {
                value: 'JAPETO_ADMIN',
                label: getUserRoleLabel('JAPETO_ADMIN')
              }
            ]
          : []),
        ...(loggedInUser?.role === 'SUPER_ADMIN'
          ? [
              {
                value: 'SUPER_ADMIN',
                label: getUserRoleLabel('SUPER_ADMIN')
              }
            ]
          : [])
      ]}
      fullWidth={fullWidth}
    />
  );
}

export default UserRoleSelector;
